// Function to set the phone field as required in the form when preferred contact method is set to phone
function setPhoneRequiredIfPreferred(){
    $("#inputContactMethod option:selected").each(function(){
        var contactMethod = $(this).val();        
        if(contactMethod == "Phone"){
            $(this).closest("form").find("#inputPhone").prop('required',true);
        }else if(contactMethod == "Email"){
            $(this).closest("form").find("#inputPhone").prop('required',false);
        }
    })
}

// Function to find multiline labels and adjust the input/textarea to prevent overlap/overflow
function findLabelOverflow (){
    $(".form-label-group label:not(.dropdown-label)").each(function(){
        var ow = $(this).outerWidth();
        var sw = $(this)[0].scrollWidth;
        var matchedInput = $("#" + $(this).attr("for"));
        matchedInput.css("padding-top", "");
        matchedInput.css("height", "");
        if(sw > ow || $(this).hasClass('multi-line-label')){
            $(this).addClass('multi-line-label');
            matchedInput.css("height", "");
            var labelHeight = $(this).height();
            var inputHeight = matchedInput.height();
            var contentHeight = matchedInput.get(0).scrollHeight;
            if(contentHeight > inputHeight){
                contentHeight = inputHeight;
            }
            matchedInput.css("padding-top", labelHeight);
            matchedInput.css("height", inputHeight * 2 + labelHeight);
        } 
    })
}
function findSelectLabelOverflow(){
    $(".form-label-group label.dropdown-label").each(function(){
        var ow = $(this).outerWidth();
        var sw = $(this)[0].scrollWidth;
        var matchedInput = $("#" + $(this).attr("for"));
        matchedInput.css("padding-top", "");
        matchedInput.css("height", "");

        if(matchedInput.hasClass('selected')){
            if(sw > ow || $(this).hasClass('multi-line-label')){
                $(this).addClass('multi-line-label');
                matchedInput.css("height", "");
                var labelHeight = $(this).height();
                var inputHeight = matchedInput.height();
                var contentHeight = matchedInput.get(0).scrollHeight;
                if(contentHeight > inputHeight){
                    contentHeight = inputHeight;
                }
                matchedInput.css("padding-top", labelHeight);
                matchedInput.css("height", inputHeight * 2 + labelHeight);
            } 
        } else {
            $(this).removeClass('multi-line-label')
        }
    })
}



$( document ).ready(function() {  
    // Handle phone field required dependant on preferred contact method selected (on load and on change)
    setPhoneRequiredIfPreferred();
    $( "#inputContactMethod" ).change(function() {
        setPhoneRequiredIfPreferred();
    });   
    // Handle multiline floating labels
    findLabelOverflow();
    findSelectLabelOverflow()
    $( window ).resize(function() {
        findLabelOverflow();
        findSelectLabelOverflow()
    })
    $(window).on('shown.bs.modal', function() { 
        findLabelOverflow();
        findSelectLabelOverflow()
    });

    $(document).on('change', ".form-label-group select", function(){
        //FLOATING LABEL SAFARI FIX
        val = $(this).find(":selected").val();
        if( typeof val != 'undefined' && val.length > 0 ){
            $(this).addClass('selected');
        } else {
            $(this).removeClass('selected');
        }

        // Floating Label Sizing
        findSelectLabelOverflow()
    })
});

// Property Search
$(document).ready(function() {
    let minPriceSelect = document.querySelector('[name="min_price"]');
    if (minPriceSelect) {
        let maxPriceSelect = document.querySelector('[name="max_price"]');
        let minOptions = minPriceSelect.querySelectorAll('option');
        let maxOptions = maxPriceSelect.querySelectorAll('option');
        let adjustMaxPrices = function() {
            let value = 0;
            let minCurrent = parseInt(minPriceSelect.value);
            for (let i = 0; i < maxOptions.length; i++) {
                value = parseInt(maxOptions[i].getAttribute('value'));
                maxOptions[i].removeAttribute('disabled');
                if (minCurrent > 0 && value > 0 && value <= minCurrent) {
                    maxOptions[i].setAttribute('disabled', 'disabled');
                }
            }
        }
        let adjustMinPrices = function() {
            let value = 0;
            let maxCurrent = parseInt(maxPriceSelect.value);
            for (let i = 0; i < minOptions.length; i++) {
                value = parseInt(minOptions[i].getAttribute('value'));
                minOptions[i].removeAttribute('disabled');
                if (maxCurrent > 0 && value > 0 && value >= maxCurrent) {
                    minOptions[i].setAttribute('disabled', 'disabled');
                }
            }
        }
        minPriceSelect.addEventListener('change', adjustMaxPrices);
        maxPriceSelect.addEventListener('change', adjustMinPrices);
        adjustMinPrices();
        adjustMaxPrices();
    }
    let propertySortSelect = document.querySelector('[sort-properties]');
    if (propertySortSelect) {
        propertySortSelect.addEventListener('change', function() {
            let path = window.location.href;
            debugger;
            if (path.indexOf('?page=') !== -1) {
                path = path.replace(/\?page=[^&]*&?/, '?');
            }
            if (path.indexOf('&page=') !== -1) {
                path = path.replace(/&page=[^&]*/g, '');
            }
            if (path.indexOf('?sort=') !== -1) {
                path = path.replace(/\?sort=[^&]*&?/, '?');
            }
            if (path.indexOf('&sort=') !== -1) {
                path = path.replace(/&sort=[^&]*/g, '');
            }
            if (path.indexOf('?') !== -1) {
                window.location = path + '&sort=' + this.value;
            } else {
                window.location = path + '?sort=' + this.value;
            }
        });
    }
    let propertySearchForm = document.querySelector('[property-search]');
    if (propertySearchForm) {
        propertySearchForm.addEventListener('submit', function() {
            if (propertySortSelect) {
                let sortHiddenField = document.createElement('input');
                sortHiddenField.setAttribute('name', 'sort');
                sortHiddenField.setAttribute('type', 'hidden');
                sortHiddenField.setAttribute('value', propertySortSelect.value);
                propertySearchForm.appendChild(sortHiddenField);
            }
            return true;
        });
    }
});